<script setup>
import { paginaNotizie } from '@/graphql/queries/notizie.js'

definePageMeta({
  layout: 'default',
})

const route = useRoute()
const slug = route.params.slug

const { locale } = useI18n()

const variables = computed(() => ({
  locale: locale.value,
  slug,
}))

const { data } = await useGraphql(paginaNotizie, variables)

if (!data.value.paginaNotizie) {
  throw createError({ statusCode: 404 })
}

const page = computed(() => data?.value?.paginaNotizie || {})
const seo = computed(() => page?.value?.seo || {})

useSeo(seo)

const allNotiziaPages = computed(() => {
  const articoloInEvidenzaSlug = page?.value?.articoloInEvidenza?.slug
  return (data?.value?.allNotiziaPages || []).filter(
    (page) => page.slug !== articoloInEvidenzaSlug,
  )
})
</script>

<template>
  <div class="notizie-page row-400-25-default max-content">
    <div class="p-top-xxl-2">
      <LazyTitleText
        v-if="page.intro"
        :block="page.intro"
        class="p-bottom-xxl-1"
      />
      <LazyPagineNotizieHighlightArticle
        v-if="page.articoloInEvidenza"
        :article="page.articoloInEvidenza"
      />
      <LazyPagineNotizieListing
        v-if="allNotiziaPages && allNotiziaPages.length"
        :notizie="allNotiziaPages"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'NotiziePage',
}
</script>
